<!-- Account Selector -->
<gl-account-selector *ngIf="env.PURCHASE_FLOW?.SHOW_USER_ACCOUNT_CHOICE"></gl-account-selector>

<div class="mb-4 bg-white shadow-md md:shadow-none">
    <h1 class="p-4 text-left text-base font-normal leading-5 md:p-0 md:font-bold">
        {{ 'CHOOSE_TICKET_TYPE' | translate }}
    </h1>
</div>
<div class="rounded-lg bg-grey-white_smoke dark:bg-contrast-black md:mb-0 md:p-4">
    <div class="var-app-light-dark:gap-0 flex w-auto flex-col gap-4 overflow-y-auto md:bg-white md:p-4">
        <button
            class="var-app-light-dark:mb-4 solid-border flex max-h-40 w-full justify-between gap-4 bg-white p-4 text-left shadow-md focus:outline-none focus-visible:rounded-lg focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-500 md:max-w-[20.5rem] md:rounded-lg"
            *ngFor="let area of areas; let index = index"
            (click)="selectArea(area.id)"
            type="button">
            <div>
                <ion-icon
                    class="orb-app-light:text-secondary orb-app-light-dark:text-[2rem] var-app-light-dark:text-[1.625rem] text-6xl text-primary dark:filter-yellow"
                    aria-hidden="true"
                    src="{{ assetsPath$ | async }}/img/purchase-flow-v2/areas/icon-product-area-{{
                        area.code?.toLowerCase()
                    }}.svg"></ion-icon>
                <h1 class="text-base font-bold leading-7 text-black dark:text-contrast-yellow">
                    {{ area.name | translateObjectField: null : currentLanguage }}
                </h1>
                <p class="text-base font-normal leading-5 text-grey-dark dark:text-contrast-yellow">
                    {{ area.description | translateObjectField: null : currentLanguage }}
                </p>
            </div>
            <div class="flex flex-col justify-center p-3">
                <ion-icon
                    class="text-black dark:text-contrast-yellow"
                    title="{{ 'CHEVRON' | translate }}"
                    aria-label="{{ 'CHEVRON' | translate }}"
                    name="chevron-forward-outline"
                    aria-hidden="true"></ion-icon>
            </div>
        </button>
    </div>
    <div
        class="var-app-light-dark:mt-0 mt-4 flex w-auto flex-col gap-4 overflow-y-auto md:bg-white md:p-4"
        *ngIf="env.PURCHASE_FLOW?.SHOW_RECENT_PURCHASE && recentTickets?.length">
        <div class="block w-full gap-4 bg-white px-4 pb-4 md:flex md:flex-col">
            <h2
                class="orb-app-light-dark:font-semibold pt-4 text-left text-xs font-normal uppercase leading-5 text-[#414141] dark:text-contrast-yellow">
                {{ 'RECENT_PURCHASES' | translate }}
            </h2>
            <button
                class="w-full text-left focus-visible:rounded-lg focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-500"
                *ngFor="let ticket of recentTickets"
                (click)="
                    selectArea(
                        ticket.typeOfProduct.type === 'single' ? 'productCategory:city-muni' : 'productCategory:area',
                        ticket
                    )
                "
                type="button">
                <rwidget-ticket-card [ticket]="ticket" [isRecent]="true"></rwidget-ticket-card>
            </button>
        </div>
    </div>
</div>
